// © Microsoft Corporation. All rights reserved.

import { SocialPopover, SocialPopoverProps } from "@msnews/social-popover";

import React from "react";
import { SocialCommentClassNameContract } from "../../SocialComment.classnames";
import { SocialCommentLocalizedStrings } from "../../SocialComment.localizedStrings";
import { StealthButton } from "@microsoft/fast-components-react-msft";
import { classNames } from "@microsoft/fast-web-utilities";
import { close2 } from "@msnews/social-utils";

export interface ProfileEducatorProps extends SocialPopoverProps {
    managedClasses: SocialCommentClassNameContract;
    t: SocialCommentLocalizedStrings;
}

export default class ProfileEducator extends React.Component<ProfileEducatorProps> {

    render() {
        const { managedClasses: mc, className, onHide } = this.props;

        return (
            <SocialPopover {...{
                ...this.props,
                visible: true,
                className: classNames(mc.profileEducatorPopover, className),
                disableAutoPosition: true,
                disablePopoverHideHandlers: true
            }}>
                <div className={classNames(mc.profileEducator)}>
                    <h6 className={classNames(mc.profileEducatorHeader, "no-select")}>View your profile</h6>
                    <p className={classNames(mc.profileEducatorMessage, "no-select")}>You can find your comments and activity feed here.</p>
                    <StealthButton
                        className={mc.profileEducatorCloseButton}
                        title="Close"
                        onClick={onHide}
                    >
                        <i className="cwt-icon"> {close2} </i>
                    </StealthButton>
                </div>
            </SocialPopover>
        );
    }
}